<template>
  <div>
    <el-card shadow="hover">
      <template slot="header">
        <div class="clearfix">
          <span>客户管理</span>
          <span style="float:right">
            <el-upload v-if="$hasPerm('func:customer:legacy-import')" action="#" :auto-upload="false" :show-file-list="false" :on-change="handleLegacyImport" accept=".xlsx,.xls" style="display:inline-block;margin-right:6px">
              <el-button type="warning" size="small" :loading="legacyImporting" icon="el-icon-upload2">原系统客户导入</el-button>
            </el-upload>
            <el-button v-if="$hasPerm('func:customer:legacy-import')" type="text" size="small" icon="el-icon-download" @click="downloadLegacyTemplate">下载模板</el-button>
          </span>
        </div>
      </template>
      <el-form :inline="true" :model="searchForm" class="mb-4 customer-toolbar">
        <el-form-item label="客户名称">
          <el-input v-model="searchForm.name" placeholder="请输入" style="width: 150px" @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="searchForm.phone" placeholder="手机号/座机片段" style="width: 170px" clearable @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item label="客户负责人">
          <el-select v-model="searchForm.responsiblePerson" placeholder="请选择" clearable filterable style="width: 130px">
            <el-option v-for="u in salesmanList" :key="u.id" :label="u.name || u.username" :value="u.name || u.username"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户标签">
          <el-select v-model="searchForm.customerLabel" placeholder="请选择" clearable>
            <el-option v-for="l in labelOptions" :key="l.id" :label="l.name" :value="l.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户类别">
          <el-select v-model="searchForm.customerCategory" placeholder="请选择" clearable>
            <el-option v-for="c in categoryOptions" :key="c.id" :label="c.name" :value="c.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="休眠状态">
          <el-select v-model="searchForm.dormantStatus" placeholder="请选择" clearable style="width: 110px">
            <el-option label="激活" :value="0"></el-option>
            <el-option label="缓冲期" :value="1"></el-option>
            <el-option label="休眠" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <!-- 强制换行：以下筛选放到搜索第二行 -->
        <div class="toolbar-break"></div>
        <el-form-item label="出库类型">
          <el-select v-model="searchForm.appOutboundType" placeholder="请选择" clearable style="width: 130px" @change="handleSearch">
            <el-option label="礼品" value="礼品"></el-option>
            <el-option label="产品试用" value="产品试用"></el-option>
            <el-option label="新出库" value="新出库"></el-option>
            <el-option label="送存货" value="送存货"></el-option>
            <el-option label="尊贵卡A" value="尊贵卡A"></el-option>
            <el-option label="尊贵卡B" value="尊贵卡B"></el-option>
            <el-option label="尊贵卡C" value="尊贵卡C"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="存货类型">
          <el-select v-model="searchForm.stockType" placeholder="请选择" clearable style="width: 130px" @change="handleSearch">
            <el-option label="普通存货" value="普通存货"></el-option>
            <el-option label="品鉴存货" value="品鉴存货"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="试用类型">
          <el-select v-model="searchForm.applicableTypeId" placeholder="请选择" clearable style="width: 130px">
            <el-option v-for="t in applicableTypeOptions" :key="t.id" :label="t.name" :value="t.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否消费">
          <el-select v-model="searchForm.consumptionStatus" placeholder="请选择" clearable style="width: 110px">
            <el-option label="已消费" :value="1"></el-option>
            <el-option label="未消费" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.appStatus" placeholder="请选择" clearable style="width: 120px">
            <el-option label="审核中" :value="0"></el-option>
            <el-option label="已驳回" :value="2"></el-option>
            <el-option label="待签字" :value="1"></el-option>
            <el-option label="已完结" :value="3"></el-option>
            <el-option label="未完结" :value="4"></el-option>
            <el-option label="已撤销" :value="6"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="有无欠款">
          <el-select v-model="searchForm.hasDebt" placeholder="请选择" clearable style="width: 110px">
            <el-option label="有欠款" :value="1"></el-option>
            <el-option label="无欠款" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
        <el-form-item class="toolbar-actions">
          <el-button
            v-if="$hasPerm('func:gift-recipient:create') || $hasPerm('func:customer:edit')"
            class="act-count-btn"
            type="warning"
            size="small"
            icon="el-icon-present"
            :disabled="!selectedIds.length"
            :loading="batchAddingToGift"
            @click="handleBatchAddToGift"
          >加入礼品名单{{ selectedIds.length ? '（' + selectedIds.length + '）' : '' }}</el-button>
          <el-button v-if="$hasPerm('func:customer:delete')" class="act-count-btn" type="danger" size="small" icon="el-icon-delete" :disabled="!selectedIds.length" @click="handleBatchDelete">批量删除{{ selectedIds.length ? '（' + selectedIds.length + '）' : '' }}</el-button>
          <el-button v-if="$hasPerm('func:customer:export')" class="act-count-btn" type="success" size="small" :disabled="!selectedIds.length" @click="handleExport" :loading="exporting">导出Excel{{ selectedIds.length ? '（' + selectedIds.length + '）' : '' }}</el-button>
          <el-button v-if="$hasPerm('func:customer:create')" type="primary" size="small" @click="openDialog()">添加客户</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="customerList" style="width: 100%" stripe size="small" border
        @row-dblclick="row => openDialog(row)" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="46" align="center"></el-table-column>
        <el-table-column v-if="false" type="expand">
          <template slot-scope="props">
            <div class="detail-panel">
              <div class="detail-panel-title clickable" @click="toggleMod(props.row.id,'base')"><i class="el-icon-info"></i><span>基础信息</span><i class="toggle-arrow" :class="modOpen(props.row.id,'base') ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i></div>
              <div class="detail-card-row dbl-edit" v-show="modOpen(props.row.id,'base')" @dblclick="openDialog(props.row)" title="双击任意位置修改客户">
                <div class="detail-card-body cols-4">
                  <div class="dc-cell"><span class="dc-label">客户ID</span><span class="dc-value">{{ props.row.id }}</span></div>
                  <div class="dc-cell"><span class="dc-label">客户姓名</span><span class="dc-value">{{ props.row.name || '-' }}</span></div>
                  <div class="dc-cell"><span class="dc-label">性别</span><span class="dc-value">{{ props.row.gender || '-' }}</span></div>
                  <div class="dc-cell"><span class="dc-label">年龄</span><span class="dc-value">{{ props.row.age || '-' }}</span></div>
                  <div class="dc-cell"><span class="dc-label">手机</span><span class="dc-value">{{ maskPhone(props.row.contactPhone) }}</span></div>
                  <div class="dc-cell"><span class="dc-label">座机</span><span class="dc-value">{{ maskPhone(props.row.telephone) }}</span></div>
                  <div class="dc-cell w2"><span class="dc-label">地址</span><span class="dc-value">{{ props.row.address || '-' }}</span></div>
                  <div class="dc-cell"><span class="dc-label">客户标签</span>
                    <el-tag :type="getLabelType(props.row.customerLabel)" size="mini">{{ props.row.customerLabel || '正常' }}</el-tag>
                  </div>
                  <!-- <div class="dc-cell"><span class="dc-label">类型</span>
                    <template v-if="rowAllTypes(props.row).length">
                      <el-tag v-for="t in rowAllTypes(props.row)" :key="t" :type="getCategoryType(t)" size="mini" style="margin-right:4px">{{ t }}</el-tag>
                    </template>
                    <span v-else class="dc-value">-</span>
                  </div> -->
                  <div class="dc-cell"><span class="dc-label">客户类别</span>
                    <el-tag v-if="props.row.customerCategory" :color="getCategoryColor(props.row.customerCategory)" :style="getCategoryColor(props.row.customerCategory) ? 'color:#fff;border-color:' + getCategoryColor(props.row.customerCategory) : ''" size="mini">{{ props.row.customerCategory }}</el-tag>
                    <span v-else class="dc-value">-</span>
                  </div>
                  <div class="dc-cell"><span class="dc-label">无效客户</span>
                    <el-tag :type="props.row.invalidCustomer === 1 ? 'danger' : 'success'" size="mini">{{ props.row.invalidCustomer === 1 ? '是' : '否' }}</el-tag>
                  </div>
                  <div class="dc-cell"><span class="dc-label">休眠状态</span>
                    <el-tag :type="dormantTagType(props.row.dormantStatusText)" size="mini">{{ props.row.dormantStatusText || '激活' }}</el-tag>
                  </div>

                  <!-- <div class="dc-cell"><span class="dc-label">免服务费剩余天数</span>
                    <span v-if="props.row.customerType === '尊贵卡A'" class="dc-value">终身</span>
                    <span v-else-if="props.row.freeServiceDays != null" class="dc-value">{{ props.row.freeServiceDays }} 天</span>
                    <span v-else class="dc-value">-</span>
                  </div> -->

                  <!-- <div class="dc-cell"><span class="dc-label">免服务费期限</span>
                    <span v-if="props.row.customerType === '尊贵卡A'" class="dc-value">终身</span>
                    <span v-else-if="props.row.freeServiceMonths != null" class="dc-value">{{ props.row.freeServiceMonths }} 个月</span>
                    <span v-else class="dc-value">-</span>
                  </div>
                  <div class="dc-cell"><span class="dc-label">服务费起始日</span>
                    <span v-if="props.row.customerType === '尊贵卡A'" class="dc-value">终身</span>
                    <span v-else class="dc-value">{{ customerServiceFeeStart(props.row) || '-' }}</span>
                  </div>
                  <div class="dc-cell"><span class="dc-label">服务费到期提醒</span>
                    <span v-if="props.row.customerType === '尊贵卡A'" class="dc-value">终身</span>
                    <span v-else class="dc-value">{{ customerServiceRemindLabel(props.row) }}</span>
                  </div> -->

                  <!-- <div class="dc-cell w2"><span class="dc-label">服务费期限</span>
                    <span v-if="props.row.customerType === '尊贵卡A'" class="dc-value">终身</span>
                    <span v-else-if="props.row.freeServicePeriod && props.row.serviceFeeStartDate" class="dc-value">{{ formatServiceTerm(props.row) }}</span>
                    <span v-else class="dc-value">-</span>
                  </div> -->

                  <!-- <div class="dc-cell"><span class="dc-label">累计提货金额</span><span class="dc-value">{{ formatMoney(props.row.pickupTotalAmount) }}</span></div> -->

                </div>
              </div>

              <div class="detail-card-row" v-show="modOpen(props.row.id,'base')">
                <div class="detail-card-body cols-4">
                  <div class="dc-cell"><span class="dc-label">开发人</span><span class="dc-value">{{ props.row.developer || '-' }}</span></div>
                  <div class="dc-cell"><span class="dc-label">客户负责人</span><span class="dc-value">{{ props.row.responsiblePerson || '-' }}</span></div>
                  <div class="dc-cell"><span class="dc-label">创建日期</span><span class="dc-value">{{ formatDate(props.row.createTime) || '-' }}</span></div>
                  <div class="dc-cell"><span class="dc-label">最新修改日期</span><span class="dc-value">{{ formatDate(props.row.updateTime) || '-' }}</span></div>
                </div>
              </div>

              <!-- 客户实际存货：按产品列出 总存货数量/已提/剩余（仅送存货来源；默认展开） -->
              <div class="detail-panel-title clickable" style="display:flex;justify-content:space-between;align-items:center;" @click="toggleStockSummary(props.row)">
                <div>
                  <i class="el-icon-box"></i><span>客户实际存货</span>
                  <i class="toggle-arrow" :class="stockSummaryOpen[props.row.id] !== false ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
                </div>
                <div v-if="stockSummaryOpen[props.row.id] !== false" @click.stop>
                  <el-radio-group :value="stockSummaryFilters[props.row.id] || ''" @input="val => setStockSummaryFilter(props.row.id, val)" size="mini">
                    <el-radio-button label="">全部</el-radio-button>
                    <el-radio-button label="普通存货">普通存货</el-radio-button>
                    <el-radio-button label="品鉴存货">品鉴存货</el-radio-button>
                  </el-radio-group>
                </div>
              </div>
              <div class="detail-card-row" v-show="stockSummaryOpen[props.row.id] !== false">
                <el-table :data="getFilteredStockSummaryRows(props.row.id)" size="small" stripe border style="width:100%"
                  :header-cell-style="{background:'#f5f7fa', color:'#606266'}">
                  <el-table-column type="index" label="序号" width="60" align="center" :index="i => getFilteredStockSummaryRows(props.row.id).length - i"></el-table-column>
                  <el-table-column prop="productName" label="产品名称" min-width="120" align="center"></el-table-column>
                  <el-table-column prop="stockType" label="存货类型" width="120" align="center">
                    <template slot-scope="s">
                      <el-tag size="small" type="warning" style="font-weight:600;">{{ s.row.stockType || '普通存货' }}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="totalStocked" label="总存货数量" min-width="100" align="center"></el-table-column>
                  <el-table-column label="已提数量" min-width="160" align="center">
                    <template slot-scope="s">
                      <div>{{ s.row.taken }}</div>
                      <div v-if="Number(s.row.newoutTaken) > 0" style="font-size:13px;color:#E6A23C;font-weight:600;margin-top:2px;">含新出库已提 {{ s.row.newoutTaken }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="remaining" label="剩余数量" min-width="100" align="center">
                    <template slot-scope="s">
                      <span style="font-weight:600;color:#67C23A;">{{ s.row.remaining }}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <div v-if="!getFilteredStockSummaryRows(props.row.id).length" class="muted" style="padding:12px;text-align:center;">暂无送存货记录</div>
              </div>

              <!-- 销售订单档案：直接复用销售订单页（嵌入模式，仅针对该客户，含展开/新建/修改/删除） -->
              <div class="detail-panel-title clickable" @click="toggleMod(props.row.id,'sales')">
                <i class="el-icon-tickets"></i><span>销售订单</span>
                <i class="toggle-arrow" :class="modOpen(props.row.id,'sales') ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
              </div>
              <div class="detail-card-row so-embed-wrap" v-show="modOpen(props.row.id,'sales')">
                <sales-order :embedded-customer="props.row"></sales-order>
              </div>

              <!-- 提货申请：统一复用 VipOrder（产品下拉已支持所有类型，普通/尊贵卡客户共用此组件样式） -->
              <div class="detail-panel-title clickable" @click="toggleMod(props.row.id,'vip')">
                <i class="el-icon-document"></i><span>提货申请</span>
                <i class="toggle-arrow" :class="modOpen(props.row.id,'vip') ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
              </div>
              <div class="detail-card-row so-embed-wrap" v-show="modOpen(props.row.id,'vip')">
                <vip-order :embedded-customer="props.row"></vip-order>
              </div>

              <!-- 审批管理：复用审批管理页（仅针对该客户） -->
              <div class="detail-panel-title clickable" @click="toggleMod(props.row.id,'approval')">
                <i class="el-icon-s-check"></i><span>审批管理</span>
                <i class="toggle-arrow" :class="modOpen(props.row.id,'approval') ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
              </div>
              <div class="detail-card-row so-embed-wrap" v-show="modOpen(props.row.id,'approval')">
                <approval-management :embedded-customer="props.row"></approval-management>
              </div>

              <!-- 出库管理：复用出库管理页（仅针对该客户） -->
              <div class="detail-panel-title clickable" @click="toggleMod(props.row.id,'outbound')">
                <i class="el-icon-truck"></i><span>出库管理</span>
                <i class="toggle-arrow" :class="modOpen(props.row.id,'outbound') ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
              </div>
              <div class="detail-card-row so-embed-wrap" v-show="modOpen(props.row.id,'outbound')">
                <outbound-management :embedded-customer="props.row"></outbound-management>
              </div>

            </div>
          </template>
        </el-table-column>
        <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod"></el-table-column>
        <el-table-column prop="name" label="客户姓名" min-width="100">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="goDetail(scope.row)">{{ scope.row.name || '-' }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="电话" min-width="160">
          <template slot-scope="scope">
            <div v-if="phoneFilled(scope.row.contactPhone)">手机：{{ maskPhone(scope.row.contactPhone) }}</div>
            <div v-if="phoneFilled(scope.row.telephone)">座机：{{ maskPhone(scope.row.telephone) }}</div>
            <div v-if="!phoneFilled(scope.row.contactPhone) && !phoneFilled(scope.row.telephone)">{{ maskPhone(scope.row.phone) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="地址" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.address || '-' }}</template>
        </el-table-column>
        <el-table-column prop="developer" label="开发人" min-width="100">
          <template slot-scope="scope">{{ scope.row.developer || '-' }}</template>
        </el-table-column>
        <el-table-column prop="responsiblePerson" label="客户负责人" min-width="120"></el-table-column>
        <el-table-column prop="customerCategory" label="客户类别" min-width="110">
          <template slot-scope="s">
            <el-tag v-if="s.row.customerCategory" :color="getCategoryColor(s.row.customerCategory)" :style="getCategoryColor(s.row.customerCategory) ? 'color:#fff;border-color:' + getCategoryColor(s.row.customerCategory) : ''" size="small">{{ s.row.customerCategory }}</el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="customerType" label="类型" min-width="200">
          <template slot-scope="s">
            <template v-if="rowAllTypes(s.row).length">
              <el-tag v-for="t in rowAllTypes(s.row)" :key="t" :type="getCategoryType(t)" size="small" style="margin-right:4px;margin-bottom:2px">{{ t }}</el-tag>
            </template>
            <span v-else>-</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="customerLabel" label="客户标签" min-width="120">
          <template slot-scope="scope">
            <el-tag :type="getLabelType(scope.row.customerLabel)" size="small">{{ scope.row.customerLabel || '正常' }}</el-tag>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="免服务费剩余天数" width="140" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.customerType === '尊贵卡A'">终身</span>
            <span v-else-if="scope.row.freeServiceDays != null">{{ scope.row.freeServiceDays }} 天</span>
            <span v-else class="muted">-</span>
          </template>
        </el-table-column> -->

        <!-- <el-table-column label="免服务费期限" width="120" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.customerType === '尊贵卡A'">终身</span>
            <span v-else-if="scope.row.freeServiceMonths != null">{{ scope.row.freeServiceMonths }} 个月</span>
            <span v-else class="muted">-</span>
          </template>
        </el-table-column>
        <el-table-column label="服务费起始日" width="130" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.customerType === '尊贵卡A'">终身</span>
            <span v-else>{{ customerServiceFeeStart(scope.row) || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="服务费到期提醒" width="160" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.customerType === '尊贵卡A'">终身</span>
            <span v-else>{{ customerServiceRemindLabel(scope.row) }}</span>
          </template>
        </el-table-column> -->

        <!-- <el-table-column label="服务费期限" width="220" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.customerType === '尊贵卡A'">终身</span>
            <span v-else-if="scope.row.freeServicePeriod && scope.row.serviceFeeStartDate">{{ formatServiceTerm(scope.row) }}</span>
            <span v-else class="muted">-</span>
          </template>
        </el-table-column> -->

        <el-table-column label="休眠状态" width="96" align="center">
          <template slot-scope="scope">
            <el-tag :type="dormantTagType(scope.row.dormantStatusText)" size="small">{{ scope.row.dormantStatusText || '激活' }}</el-tag>
          </template>
        </el-table-column>

        <!-- <el-table-column label="无效客户" width="96" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.invalidCustomer === 1 ? 'danger' : 'success'" size="small">{{ scope.row.invalidCustomer === 1 ? '是' : '否' }}</el-tag>
          </template>
        </el-table-column> -->
        <el-table-column prop="id" label="客户ID" width="80" align="center"></el-table-column>
        <el-table-column label="操作" width="160" align="center">
          <template slot-scope="scope">
            <el-button v-if="$hasPerm('func:customer:edit')" type="primary" size="mini" @click="openDialog(scope.row)">修改</el-button>
            <el-button v-if="$hasPerm('func:customer:delete')" type="danger" size="mini" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="mt-4">
        <el-pagination @size-change="s => { pageSize = s; getCustomerList() }" @current-change="p => { currentPage = p; getCustomerList() }" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </el-card>

    <!-- 添加/编辑对话框：基础信息 + 系统信息 两块。统一 3 列布局 -->
    <el-dialog :title="form.id ? '编辑客户' : '添加客户'" :visible.sync="dialogVisible" width="880px" top="6vh" custom-class="customer-dialog" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="form" :rules="rules" ref="form" label-width="110px" size="small">
            <el-row :gutter="24">
              <el-col :span="12"><el-form-item label="客户ID">
                <el-input :value="form.id" disabled placeholder="创建后自动生成"></el-input>
              </el-form-item></el-col>
              <el-col :span="12"><el-form-item label="客户姓名" prop="name">
                <el-input v-model="form.name" placeholder="请输入客户姓名"></el-input>
              </el-form-item></el-col>
              <el-col :span="12"><el-form-item label="性别">
                <el-radio-group v-model="form.gender">
                  <el-radio label="男">男</el-radio>
                  <el-radio label="女">女</el-radio>
                </el-radio-group>
              </el-form-item></el-col>
              <el-col :span="12"><el-form-item label="年龄">
                <el-input-number v-model="form.age" :min="0" :max="150" controls-position="right" style="width: 100%" placeholder="请输入年龄"></el-input-number>
              </el-form-item></el-col>
              <el-col :span="12"><el-form-item label="手机" prop="contactPhone">
                <el-input v-model="form.contactPhone" placeholder="请输入手机号" maxlength="11"></el-input>
              </el-form-item></el-col>
              <el-col :span="12"><el-form-item label="座机" prop="telephone">
                <el-input v-model="form.telephone" placeholder="请输入座机号" maxlength="20"></el-input>
              </el-form-item></el-col>
              <el-col :span="24"><el-form-item label="地址">
                <el-input v-model="form.address" placeholder="请输入详细地址"></el-input>
              </el-form-item></el-col>

              <!-- 开发人 客户负责人 放在地址的下面 -->
              <el-col :span="12"><el-form-item label="开发人" prop="developer">
                <el-input v-model="form.developer" placeholder="请输入开发人"></el-input>
              </el-form-item></el-col>
              <el-col :span="12"><el-form-item label="客户负责人" prop="responsiblePerson">
                <el-select v-model="form.responsiblePerson" filterable placeholder="请选择业务员" style="width: 100%">
                  <el-option v-for="u in salesmanList" :key="u.id" :label="u.name || u.username" :value="u.name || u.username"></el-option>
                </el-select>
              </el-form-item></el-col>

              <!-- 客户标签 放在客户类别的前面 他俩同一行 -->
              <el-col :span="12"><el-form-item label="客户标签">
                <el-select v-model="form.customerLabel" placeholder="选择标签" clearable style="width: 100%">
                  <el-option v-for="l in labelOptions" :key="l.id" :label="l.name" :value="l.name"></el-option>
                </el-select>
              </el-form-item></el-col>
              <el-col :span="12"><el-form-item label="客户类别">
                <el-select v-model="form.customerCategory" placeholder="请选择类别" clearable style="width:100%">
                  <el-option v-for="c in categoryOptions" :key="c.id" :label="c.name" :value="c.name"></el-option>
                </el-select>
              </el-form-item></el-col>

              <el-col :span="12"><el-form-item label="无效客户">
                <el-radio-group v-model="form.invalidCustomer">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是</el-radio>
                </el-radio-group>
              </el-form-item></el-col>
              <el-col :span="12"><el-form-item label="创建日期">
                <el-input :value="formatDate(form.createTime)" disabled placeholder="创建后自动生成"></el-input>
              </el-form-item></el-col>
              <el-col :span="12"><el-form-item label="最新修改日期">
                <el-input :value="formatDate(form.updateTime)" disabled placeholder="保存后自动更新"></el-input>
              </el-form-item></el-col>
            </el-row>

      </el-form>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="success" @click="handleSubmit">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="legacyResult && legacyResult.dryRun ? '原系统客户导入 · 预览（试运行）' : '原系统客户导入结果'" :visible.sync="legacyResultVisible" width="640px" top="6vh" :close-on-click-modal="false" :close-on-press-escape="false">
      <div v-if="legacyResult">
        <el-alert v-if="!legacyResult.success" type="error" :closable="false" show-icon
                  :title="legacyResult.message" style="margin-bottom:12px"></el-alert>
        <el-alert v-else-if="legacyResult.dryRun" type="warning" :closable="false" show-icon
                  :title="legacyResult.message" style="margin-bottom:12px"></el-alert>
        <el-alert v-else type="success" :closable="false" show-icon
                  :title="legacyResult.message" style="margin-bottom:12px"></el-alert>

        <div v-if="legacyResult.productErrors && legacyResult.productErrors.length" style="margin-bottom:10px">
          <p class="lg-h">以下产品在「商品管理」不存在，请先维护后重新导入（本次未导入任何数据）：</p>
          <el-tag v-for="(p,i) in legacyResult.productErrors" :key="'pe'+i" type="danger" size="small" style="margin:2px">{{ p }}</el-tag>
        </div>

        <div v-if="legacyResult.trialTypeErrors && legacyResult.trialTypeErrors.length" style="margin-bottom:10px">
          <p class="lg-h">以下试用类型在「商品适用类型」不存在，请先维护后重新导入（本次未导入任何数据）：</p>
          <el-tag v-for="(t,i) in legacyResult.trialTypeErrors" :key="'te'+i" type="danger" size="small" style="margin:2px">{{ t }}</el-tag>
        </div>

        <div v-if="legacyResult.validationErrors && legacyResult.validationErrors.length" style="margin-bottom:10px">
          <p class="lg-h">历史出库记录必填校验未通过（本次未导入任何数据）：</p>
          <div style="max-height:160px;overflow-y:auto;background:#fff1f0;border:1px solid #ffccc7;border-radius:4px;padding:8px 12px;">
            <div v-for="(err,i) in legacyResult.validationErrors" :key="'ve'+i" style="color:#cf1322;font-size:12px;line-height:1.8">• {{ err }}</div>
          </div>
        </div>

        <template v-if="legacyResult.success">
          <el-descriptions :column="2" border size="small" style="margin-bottom:12px">
            <el-descriptions-item label="新建客户">{{ legacyResult.customers ? legacyResult.customers.created : 0 }}</el-descriptions-item>
            <el-descriptions-item label="更新客户">{{ legacyResult.customers ? legacyResult.customers.updated : 0 }}</el-descriptions-item>
            <el-descriptions-item label="销售订单档案">{{ legacyResult.orders }}</el-descriptions-item>
            <el-descriptions-item label="历史出库单">{{ legacyResult.outbounds }}</el-descriptions-item>
          </el-descriptions>

          <div v-if="legacyResult.mergedExisting && legacyResult.mergedExisting.length" style="margin-bottom:10px">
            <p class="lg-h">⚠ 以下姓名已存在，已并入同名客户（请确认是否同一人）：</p>
            <el-tag v-for="(m,i) in legacyResult.mergedExisting" :key="'mg'+i" type="warning" size="small" style="margin:2px">{{ m }}</el-tag>
          </div>

          <div v-if="legacyResult.mismatches && legacyResult.mismatches.length" style="margin-bottom:10px">
            <p class="lg-h">校验不符（已照常导入，并写入客户提示，可后续人工核对）：</p>
            <el-table :data="legacyResult.mismatches" size="mini" border max-height="220">
              <el-table-column prop="customer" label="客户" width="100"></el-table-column>
              <el-table-column prop="type" label="类型" width="90"></el-table-column>
              <el-table-column prop="product" label="产品" width="120"></el-table-column>
              <el-table-column prop="kind" label="校验项" width="70"></el-table-column>
              <el-table-column prop="system" label="系统算"></el-table-column>
              <el-table-column prop="filled" label="客户填"></el-table-column>
            </el-table>
          </div>

          <div v-if="legacyResult.stockWarnings && legacyResult.stockWarnings.length">
            <p class="lg-h">库存告警（历史出库后库存为负，请知悉）：</p>
            <el-tag v-for="(w,i) in legacyResult.stockWarnings" :key="'sw'+i" type="danger" size="small" style="margin:2px">
              {{ w.product }}：{{ w.stock }}
            </el-tag>
          </div>

          <div v-if="!legacyResult.dryRun && legacyResult.batchNo"
               style="margin-top:12px;padding:10px 12px;background:#f4f4f5;border-radius:6px;display:flex;align-items:center;justify-content:space-between">
            <span>本次导入批次号：<b>{{ legacyResult.batchNo }}</b>（如发现导错可一键撤销）</span>
            <el-button size="small" type="danger" plain :loading="legacyImporting" @click="handleLegacyRevert(legacyResult.batchNo)">撤销本次导入</el-button>
          </div>
        </template>
      </div>
      <div slot="footer">
        <template v-if="legacyResult && legacyResult.success && legacyResult.dryRun">
          <el-button size="small" @click="legacyResultVisible = false">取消</el-button>
          <el-button size="small" type="primary" :loading="legacyImporting" @click="handleLegacyConfirm">确认正式导入</el-button>
        </template>
        <el-button v-else size="small" type="primary" @click="legacyResultVisible = false">知道了</el-button>
      </div>
    </el-dialog>

    <!-- 导出客户信息弹窗 -->
    <el-dialog title="导出客户信息" :visible.sync="exportDialogVisible" width="460px" :close-on-click-modal="false">
      <div style="margin-bottom:10px;color:#909399;font-size:13px;">
        已勾选 {{ selectedIds.length }} 位客户，请勾选要导出的模块（每个模块一个 Sheet）：
      </div>
      <el-checkbox :indeterminate="exportIndeterminate" v-model="exportCheckAll" @change="onExportCheckAll">全选</el-checkbox>
      <el-divider style="margin:10px 0;"></el-divider>
      <el-checkbox-group v-model="exportModules" @change="onExportModulesChange">
        <el-checkbox v-for="m in exportModuleOptions" :key="m.value" :label="m.value" style="display:block;margin:8px 0;">{{ m.label }}</el-checkbox>
      </el-checkbox-group>
      <span slot="footer">
        <el-button @click="exportDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="exporting" :disabled="!exportModules.length" @click="doExport">导出</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { customerApi, exportApi, userApi, legacyImportApi, giftRecipientApi } from '../api/api'
import SalesOrder from './SalesOrder.vue'
import NormalOrder from './NormalOrder.vue'
import VipOrder from './VipOrder.vue'
import ApprovalManagement from './ApprovalManagement.vue'
import OutboundManagement from './OutboundManagement.vue'

export default {
  components: { SalesOrder, NormalOrder, VipOrder, ApprovalManagement, OutboundManagement },
  data() {
    return {
      customerList: [],
      selectedIds: [],   // 批量操作：当前勾选的客户 id
      batchAddingToGift: false,
      searchForm: { name: '', phone: '', customerLabel: '', customerCategory: '', responsiblePerson: '', dormantStatus: '', hasDebt: '', appStatus: '', appOutboundType: '', stockType: '', applicableTypeId: '', consumptionStatus: '' },
      labelOptions: [],
      categoryOptions: [],
      applicableTypeOptions: [],
      salesmanList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      // 客户展开行：该客户的销售订单档案 / 提交申请记录（普通订单 + 尊贵卡订单）
      custSalesOrders: {},
      custNormalApps: {},
      custVipApps: {},
      custApprovals: {},
      custOutbounds: {},
      ordersLoading: {},
      modCollapse: {},
      form: {},
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        developer: [{ required: true, message: '请输入开发人', trigger: 'blur' }],
        responsiblePerson: [{ required: true, message: '请选择客户负责人', trigger: 'change' }],
        contactPhone: [
          // 手机号和座机号至少填一项 —— 此校验器也兼任座机的"至少一项"提示
          { validator: (rule, value, cb) => {
              const mobile = (value || '').trim()
              const tel = (this.form.telephone || '').trim()
              if (!mobile && !tel) return cb(new Error('手机号和座机号至少填写一项'))
              if (mobile && !/^1[3-9]\d{9}$/.test(mobile)) return cb(new Error('请输入正确的 11 位手机号'))
              cb()
            }, trigger: 'blur' }
        ],
        telephone: [
          { validator: (rule, value, cb) => {
              const tel = (value || '').trim()
              const mobile = (this.form.contactPhone || '').trim()
              if (!mobile && !tel) return cb(new Error('手机号和座机号至少填写一项'))
              if (tel && !/^[\d\-]{6,20}$/.test(tel)) return cb(new Error('请输入正确的座机号（数字或含连字符，6~20 位）'))
              cb()
            }, trigger: 'blur' }
        ]
      },
      exporting: false,
      exportDialogVisible: false,
      exportCheckAll: true,
      exportIndeterminate: false,
      exportModuleOptions: [
        { value: 'base', label: '客户基础信息' },
        { value: 'stock', label: '客户实际存货' },
        { value: 'trial', label: '产品试用记录' },
        { value: 'vipcards', label: '尊贵卡剩余可领取' },
        { value: 'order', label: '销售订单（含明细）' },
        { value: 'pickup', label: '提货申请' },
        { value: 'approval', label: '审批管理' },
        { value: 'outbound', label: '出库管理' }
      ],
      exportModules: ['base', 'stock', 'trial', 'vipcards', 'order', 'pickup', 'approval', 'outbound'],
      legacyImporting: false,
      legacyResultVisible: false,
      legacyResult: null,
      legacyFile: null,
      // 客户实际存货模块：按 customerId 缓存展开态和数据
      stockSummaryOpen: {},
      stockSummaryFilters: {},
      stockSummaryRows: {}
    }
  },
  mounted() {
    this.getCustomerList()
    this.loadLabels()
    this.loadCategories()
    this.loadApplicableTypes()
    this.loadSalesmen()
  },
  methods: {
    serviceTermEndDate(row) {
      if (!row) return null
      const start = String(row.serviceFeeStartDate || '').slice(0, 10)
      const period = (row.freeServicePeriod || '').trim()
      if (!start || !period) return null
      const m = period.match(/^(\d+)\s*(年|个月|月|天|日)$/)
      if (!m) return null
      const n = Number(m[1])
      const unit = m[2]
      const d = new Date(start.replace(/-/g, '/'))
      if (isNaN(d.getTime())) return null
      if (unit === '年') d.setMonth(d.getMonth() + n * 12)
      else if (unit === '个月' || unit === '月') d.setMonth(d.getMonth() + n)
      else d.setDate(d.getDate() + n)
      return d
    },
    fmtDate(d) {
      if (!d) return ''
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },
    formatServiceTerm(row) {
      const end = this.serviceTermEndDate(row)
      if (!end) return ''
      const start = String(row.serviceFeeStartDate || '').slice(0, 10)
      return start + ' 至 ' + this.fmtDate(end)
    },
    // 客户类型聚合：优先用后端写入的 allTypes（已合并 customerType + 销售订单 + 出库申请类型）；
    // 退化时从 customerType CSV 自行 split
    rowAllTypes(row) {
      if (!row) return []
      if (Array.isArray(row.allTypes) && row.allTypes.length) return row.allTypes
      const csv = String(row.customerType || '').split(/[,，]/).map(s => s.trim()).filter(Boolean)
      return csv
    },
    // 派生服务费起始日 = 合同起始日 + 免服务期月数（与 SalesOrder.vue 同口径）
    customerServiceFeeStart(row) {
      const s = String(row && row.serviceFeeStartDate || '').slice(0, 10)
      if (!s) return ''
      const parts = s.split('-').map(Number)
      if (parts.length < 3 || parts.some(isNaN)) return ''
      const d = new Date(parts[0], parts[1] - 1, parts[2])
      if (isNaN(d.getTime())) return ''
      const m = Number(row.freeServiceMonths) > 0 ? Number(row.freeServiceMonths) : 0
      d.setMonth(d.getMonth() + m)
      const yyyy = d.getFullYear()
      const mm = String(d.getMonth() + 1).padStart(2, '0')
      const dd = String(d.getDate()).padStart(2, '0')
      return `${yyyy}-${mm}-${dd}`
    },
    // 服务费到期提醒展示：优先用后端写入的 serviceRemindDate；
    // 若后端为空说明已逾期或无下一未缴年度，前端用同口径派生算出"已逾期 N 天"或纯日期
    customerServiceRemindLabel(row) {
      if (!row) return '-'
      if (row.serviceRemindDate) return String(row.serviceRemindDate).slice(0, 10)
      // 派生兜底
      const feeStartStr = this.customerServiceFeeStart(row)
      if (!feeStartStr) return '-'
      const parts = feeStartStr.split('-').map(Number)
      const paid = new Set(
        String(row.serviceFeePaidYears || '').split(',').map(s => s.trim()).filter(Boolean).map(Number).filter(n => !isNaN(n))
      )
      let cur = new Date(parts[0], parts[1] - 1, parts[2])
      let nextDue = null
      for (let i = 0; i < 200; i++) {
        if (!paid.has(cur.getFullYear())) { nextDue = new Date(cur.getTime()); break }
        cur.setFullYear(cur.getFullYear() + 1)
      }
      if (!nextDue) return '-'
      const today = new Date(); today.setHours(0, 0, 0, 0)
      const days = Math.round((nextDue - today) / 86400000)
      if (days < 0) return `已逾期 ${-days} 天`
      const warn = Number(row.orderExpiryWarningDays) > 0
        ? Number(row.orderExpiryWarningDays)
        : (Number(row.expiryWarningDays) > 0 ? Number(row.expiryWarningDays) : 30)
      const remind = new Date(nextDue.getTime()); remind.setDate(remind.getDate() - warn)
      const yyyy = remind.getFullYear()
      const mm = String(remind.getMonth() + 1).padStart(2, '0')
      const dd = String(remind.getDate()).padStart(2, '0')
      return `${yyyy}-${mm}-${dd}`
    },
    serviceRemindDate(row) {
      if (!row) return ''
      const start = String(row.serviceFeeStartDate || '').slice(0, 10)
      if (!start) return ''
      const years = String(row.serviceFeePaidYears || '')
        .split(',').map(s => s.trim()).filter(Boolean).map(Number).filter(n => !isNaN(n))
      if (!years.length) return ''
      const maxY = Math.max(...years)
      const parts = start.split('-').map(Number)
      const m = parts[1]
      const day = parts[2]
      const d = new Date(maxY + 1, m - 1, day)
      if (isNaN(d.getTime())) return ''
      const warnDays = Number(row.orderExpiryWarningDays) > 0 ? Number(row.orderExpiryWarningDays) : 30
      d.setDate(d.getDate() - warnDays)
      return this.fmtDate(d)
    },
    calcRemindDate(validDate, days) {
      if (!validDate) return ''
      const n = Number(days) > 0 ? Number(days) : 30
      const d = new Date(validDate)
      d.setDate(d.getDate() - n)
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },
    displayRemindDate(row) {
      return row.remindDate || this.calcRemindDate(row.validDate, row.expiryWarningDays)
    },
    loadLabels() {
      import('axios').then(({ default: axios }) => {
        axios.get('/customer-label/list').then(res => {
          const list = Array.isArray(res.data) ? res.data : []
          this.labelOptions = list.filter(l => l.enabled !== 0)
        }).catch(() => {})
      })
    },
    loadCategories() {
      import('axios').then(({ default: axios }) => {
        axios.get('/customer-category/list').then(res => {
          const list = Array.isArray(res.data) ? res.data : []
          this.categoryOptions = list.filter(c => c.enabled !== 0)
        }).catch(() => {})
      })
    },
    loadApplicableTypes() {
      import('axios').then(({ default: axios }) => {
        axios.get('/applicable-type/list').then(res => {
          const list = Array.isArray(res.data) ? res.data : []
          this.applicableTypeOptions = list.filter(t => t.enabled !== 0)
        }).catch(() => { this.applicableTypeOptions = [] })
      })
    },
    loadSalesmen() {
      userApi.getUserList().then(res => {
        const list = Array.isArray(res.data) ? res.data : []
        this.salesmanList = list.filter(u => (u.role === 'salesman' || u.roleId === 3) && u.status !== 0)
      }).catch(() => { this.salesmanList = [] })
    },
    onExpiryWarningDaysChange(n) {
      if (!this.form.validDate) return
      this.$set(this.form, 'remindDate', this.calcRemindDate(this.form.validDate, n))
    },
    // 把当前搜索条件拼成请求参数（列表/导出共用）
    buildSearchParams() {
      const params = {}
      if (this.searchForm.name) params.name = this.searchForm.name
      if (this.searchForm.phone && this.searchForm.phone.trim()) params.phone = this.searchForm.phone.trim()
      if (this.searchForm.customerLabel) params.customerLabel = this.searchForm.customerLabel
      if (this.searchForm.customerCategory) params.customerCategory = this.searchForm.customerCategory
      if (this.searchForm.responsiblePerson) params.responsiblePerson = this.searchForm.responsiblePerson
      if (this.searchForm.dormantStatus !== '' && this.searchForm.dormantStatus !== null) params.dormantStatus = this.searchForm.dormantStatus
      if (this.searchForm.hasDebt !== '' && this.searchForm.hasDebt !== null) params.hasDebt = this.searchForm.hasDebt
      if (this.searchForm.appStatus !== '' && this.searchForm.appStatus !== null) params.appStatus = this.searchForm.appStatus
      if (this.searchForm.appOutboundType) params.appOutboundType = this.searchForm.appOutboundType
      if (this.searchForm.stockType) params.stockType = this.searchForm.stockType
      if (this.searchForm.applicableTypeId !== '' && this.searchForm.applicableTypeId !== null) params.applicableTypeId = this.searchForm.applicableTypeId
      if (this.searchForm.consumptionStatus !== '' && this.searchForm.consumptionStatus !== null) params.consumptionStatus = this.searchForm.consumptionStatus
      return params
    },
    getCustomerList() {
      const params = this.buildSearchParams()
      customerApi.getCustomerPage(this.currentPage, this.pageSize, params).then(res => {
        this.customerList = res.data.records || []
        this.total = res.data.total || this.customerList.length
      })
    },
    // —— 销售订单档案：与销售订单页一致的展示口径 ——
    salesCategoryTag(c) {
      if (c === '送存货') return 'warning'
      if (c === '尊贵卡A') return 'success'
      if (c === '尊贵卡B') return 'primary'
      if (c === '尊贵卡C') return 'info'
      return ''
    },
    salesRowDebt(o) {
      return ((o.details || []).reduce((s, d) => s + (Number(d.debt) || 0), 0)).toFixed(2)
    },
    // —— 协议附件：与销售订单页一致 ——
    agreementList(row) {
      if (!row || !row.agreementUrl) return []
      return String(row.agreementUrl).split(',').map(s => s.trim()).filter(Boolean)
    },
    isAgreementImage(url) {
      if (!url) return false
      return /\.(png|jpe?g|gif|bmp|webp)(\?|$)/i.test(url)
    },
    agreementFullUrl(url) {
      if (!url) return ''
      if (/^(https?:|data:)/i.test(url)) return url
      const origin = (axios.defaults.baseURL || '').replace(/\/api\/?$/, '')
      return (origin || '') + url
    },
    openAgreement(url) {
      if (!url) return
      window.open(this.agreementFullUrl(url), '_blank')
    },
    // 客户类型判定：尊贵卡 A/B/C → 展示尊贵卡申请记录；礼品/产品试用/新出库/送存货等 → 展示普通订单申请记录
    isVipCustomer(row) {
      const t = (row && row.customerType) || ''
      return t.indexOf('尊贵卡') === 0
    },
    // 展开行内每个模块的折叠状态（默认展开）
    modOpen(id, key) {
      return this.modCollapse[id + '_' + key] !== true
    },
    toggleMod(id, key) {
      const k = id + '_' + key
      this.$set(this.modCollapse, k, this.modCollapse[k] !== true)
    },
    // 客户实际存货模块：默认展开。toggle 时在 true/false 间切换；展开时拉接口
    toggleStockSummary(row) {
      const id = row.id
      const isOpen = this.stockSummaryOpen[id] !== false // 默认 true
      if (isOpen) {
        this.$set(this.stockSummaryOpen, id, false)
        return
      }
      this.$set(this.stockSummaryOpen, id, true)
      this.loadStockSummary(id)
    },
    setStockSummaryFilter(cid, val) {
      this.$set(this.stockSummaryFilters, cid, val)
    },
    getFilteredStockSummaryRows(cid) {
      const rows = this.stockSummaryRows[cid] || []
      const filter = this.stockSummaryFilters[cid] || ''
      if (!filter) return rows
      return rows.filter(r => (r.stockType || '普通存货') === filter)
    },
    loadStockSummary(id) {
      axios.get(`/customer/${id}/stock-summary`).then(res => {
        const rows = (res.data && res.data.rows) || []
        this.$set(this.stockSummaryRows, id, rows)
      }).catch(() => {
        this.$set(this.stockSummaryRows, id, [])
      })
    },
    goDetail(row) {
      if (!row || !row.id) return
      this.$router.push('/customer/' + row.id)
    },
    // 客户行展开时：默认拉一次"客户实际存货"数据（默认展开态需要数据）
    onCustomerExpand(row, expandedRows) {
      const expanded = Array.isArray(expandedRows) && expandedRows.some(r => r && r.id === row.id)
      if (expanded && this.stockSummaryOpen[row.id] !== false) {
        this.loadStockSummary(row.id)
      }
    },
    // —— 提交申请记录：状态/类型映射，与普通订单/尊贵卡订单页一致 ——
    appStatusTag(s) {
      const m = { 0: 'warning', 1: 'primary', 2: 'danger', 3: 'success', 4: 'info', 5: 'warning' }
      return m[s] || ''
    },
    normalStatusLabel(type, s) {
      const isGiftOrTrial = type === '礼品' || type === '试用'
      const m = {
        0: '审核中',
        1: isGiftOrTrial ? '待出库' : '待签字',
        2: '已驳回',
        3: '已完结',
        4: '未完结',
        5: isGiftOrTrial ? '待出库' : '已签字（待出库）'
      }
      return m[s] != null ? m[s] : s
    },
    normalTypeTag(t) {
      if (t === '礼品') return 'warning'
      if (t === '试用') return 'success'
      if (t === '送存货') return 'primary'
      return ''
    },
    vipStatusLabel(s) {
      const m = { 0: '审核中', 1: '待签字', 2: '已驳回', 3: '已完结', 4: '未付款', 5: '已签字（待出库）' }
      return m[s] != null ? m[s] : s
    },
    vipCardTag(c) {
      if (c === '尊贵卡A') return 'success'
      if (c === '尊贵卡B') return 'primary'
      if (c === '尊贵卡C') return 'info'
      return ''
    },
    // 电话是否真正填写：空 / 占位值 00000000000 都视为未填
    phoneFilled(v) {
      const s = (v == null ? '' : String(v)).trim()
      return s !== '' && s !== '00000000000' && !/^0+$/.test(s)
    },
    maskPhone(v) {
      if (!this.phoneFilled(v)) return '-'
      const s = String(v).trim()
      const me = JSON.parse(sessionStorage.getItem('user') || '{}')
      const isAdmin = me && me.role === 'admin' && Number(me.roleId) !== 1
      if (!isAdmin) return s
      if (s.length === 11) return s.slice(0, 3) + '****' + s.slice(7)
      if (s.length >= 7) return s.slice(0, 3) + '****' + s.slice(-2)
      return s.slice(0, 2) + '***'
    },
    // —— 审批管理 / 出库管理：与对应页面一致 ——
    outTypeTag(t) {
      if (t === '礼品') return 'warning'
      if (t === '新出库') return 'danger'
      return 'primary'
    },
    vipNames(joined, type) {
      if (!joined || !(type && String(type).startsWith('尊贵卡'))) return joined
      return String(joined).split(/[,，、]\s*/).filter(s => s !== '').map(s => s.startsWith('尊贵卡-') ? s : ('尊贵卡-' + s)).join('、')
    },
    handleSearch() { this.currentPage = 1; this.getCustomerList() },
    resetSearch() { this.searchForm = { name: '', phone: '', customerLabel: '', customerCategory: '', responsiblePerson: '', dormantStatus: '', hasDebt: '', appStatus: '', appOutboundType: '', stockType: '', applicableTypeId: '', consumptionStatus: '' }; this.handleSearch() },
    // 表格序号：倒序编号 —— 最新的（列表最上面）= 最大序号 N，最旧的 = 1
    indexMethod(index) {
      return this.total - ((this.currentPage - 1) * this.pageSize + index)
    },
    getCategoryColor(name) {
      if (!name) return ''
      const it = (this.categoryOptions || []).find(c => c.name === name)
      return (it && it.color) || ''
    },
    openDialog(row) {
      if (row) {
        this.form = { ...row }
        // 老数据可能只有 phone，没有 contactPhone/telephone：按格式智能反填
        // —— 11 位 1 开头视为手机号，其它视为座机
        if (!this.form.contactPhone && !this.form.telephone && this.form.phone) {
          if (/^1[3-9]\d{9}$/.test(this.form.phone)) {
            this.form.contactPhone = this.form.phone
          } else {
            this.form.telephone = this.form.phone
          }
        }
        // 历史 contactPhone 可能存放的是座机（旧规则允许两种格式合一）—— 不像手机就归到 telephone
        if (this.form.contactPhone && !/^1[3-9]\d{9}$/.test(this.form.contactPhone) && !this.form.telephone) {
          this.form.telephone = this.form.contactPhone
          this.form.contactPhone = ''
        }
        // 自动规则阈值留空时回填默认
        if (this.form.expiryWarningDays == null || this.form.expiryWarningDays === '') this.form.expiryWarningDays = 30
        if (this.form.inactiveMonths == null || this.form.inactiveMonths === '') this.form.inactiveMonths = 12
        if (this.form.yearlySpendLimit == null || this.form.yearlySpendLimit === '') this.form.yearlySpendLimit = 100000
        // 已有有效日期但提醒日期为空 → 按客户提示天数（或默认 30）补齐
        if (this.form.validDate && !this.form.remindDate) {
          this.$set(this.form, 'remindDate', this.calcRemindDate(this.form.validDate, this.form.expiryWarningDays))
        }
      } else {
        const me = JSON.parse(sessionStorage.getItem('user') || '{}')
        this.form = {
          gender: '男',
          invalidCustomer: 0,
          dormantStatus: 0,
          creator: me.name || me.username || '',
          expiryWarningDays: 30,
          inactiveMonths: 12,
          yearlySpendLimit: 100000
        }
      }
      // 类型字段：customerType 是 CSV 字符串，弹窗用数组多选；split 时去空并 trim
      this.$set(this.form, 'customerTypeArr',
        String(this.form.customerType || '').split(/[,，]/).map(s => s.trim()).filter(Boolean))
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        // phone 是数据库 NOT NULL：手机号优先，座机号兜底
        if (this.form.contactPhone) this.form.phone = this.form.contactPhone
        else if (this.form.telephone) this.form.phone = this.form.telephone
        // 多选类型回写：数组 → CSV 存 customerType
        this.form.customerType = (this.form.customerTypeArr || []).join(',')
        const api = this.form.id ? customerApi.updateCustomer(this.form) : customerApi.addCustomer(this.form)
        api.then(res => {
          if (res.data) {
            this.$message.success(this.form.id ? '更新成功' : '添加成功')
            this.dialogVisible = false
            this.getCustomerList()
          } else {
            this.$message.error('操作失败')
          }
        })
      })
    },
    handleDelete(id) {
      this.$confirm(
        '彻底删除该客户：将永久删除该客户及其全部订单、出库申请、提货/审批记录、提示等数据，且不可恢复！（库存不回滚）确定删除？',
        '删除客户',
        { type: 'warning', confirmButtonText: '确定彻底删除', cancelButtonText: '取消', confirmButtonClass: 'el-button--danger' }
      ).then(() => {
        customerApi.deleteCustomer(id).then(res => {
          if (res.data) {
            this.$message.success('删除成功')
            this.getCustomerList()
          }
        })
      }).catch(() => {})
    },
    // 表格多选变化
    handleSelectionChange(rows) {
      this.selectedIds = (rows || []).map(r => r.id)
    },
    // 批量将勾选客户加入礼品名单
    handleBatchAddToGift() {
      const ids = this.selectedIds.slice()
      if (!ids.length) {
        this.$message.warning('请先勾选要加入礼品名单的客户')
        return
      }
      this.$confirm(
        `确定将已勾选的 <b>${ids.length}</b> 位客户批量加入【礼品名单】吗？<br/><br/>
        <span style="font-size:12px; color:#909399;">
          ・系统将自动带入客户姓名、开发人与客户负责人，并锁定档案关联<br/>
          ・已在礼品名单中的客户将自动跳过，绝不产生重复记录
        </span>`,
        '批量加入礼品名单确认',
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定加入',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        this.batchAddingToGift = true
        giftRecipientApi.batchAddFromCustomers(ids).then(res => {
          const d = res.data || {}
          if (d.success) {
            this.$message.success(d.message || '加入成功')
          } else {
            this.$message.error(d.message || '加入失败')
          }
        }).catch(err => {
          console.error(err)
          this.$message.error('操作失败，请重试')
        }).finally(() => {
          this.batchAddingToGift = false
        })
      }).catch(() => {})
    },
    // 批量删除选中客户
    handleBatchDelete() {
      const ids = this.selectedIds.slice()
      if (!ids.length) { this.$message.warning('请先勾选要删除的客户'); return }
      this.$confirm(
        `彻底删除选中的 ${ids.length} 个客户：将永久删除这些客户及其全部订单、出库申请、提货/审批记录、提示等数据，且不可恢复！（库存不回滚）确定删除？`,
        '批量彻底删除',
        { type: 'warning', confirmButtonText: '确定彻底删除', cancelButtonText: '取消', confirmButtonClass: 'el-button--danger' }
      ).then(() => {
        customerApi.batchDeleteCustomers(ids).then(res => {
          const d = res.data || {}
          this.$message.success('已删除 ' + (d.deleted != null ? d.deleted : ids.length) + ' 个客户')
          this.selectedIds = []
          this.getCustomerList()
        })
      }).catch(() => {})
    },
    toggleDormant(row) {
      const newStatus = row.dormantStatus === 1 ? 0 : 1
      customerApi.toggleDormant(row.id, newStatus).then(res => {
        if (res.data.success) {
          this.$message.success('操作成功')
          this.getCustomerList()
        }
      })
    },
    // 打开导出弹窗（与客户详情一致，支持选择导出模块）
    handleExport() {
      if (!this.selectedIds.length) { this.$message.warning('请先勾选要导出的客户'); return }
      this.exportModules = this.exportModuleOptions.map(m => m.value)
      this.exportCheckAll = true
      this.exportIndeterminate = false
      this.exportDialogVisible = true
    },
    onExportCheckAll(val) {
      this.exportModules = val ? this.exportModuleOptions.map(m => m.value) : []
      this.exportIndeterminate = false
    },
    onExportModulesChange(val) {
      const n = val.length, total = this.exportModuleOptions.length
      this.exportCheckAll = n === total
      this.exportIndeterminate = n > 0 && n < total
    },
    /** 按勾选的模块导出所选客户信息（每模块一个 Sheet） */
    doExport() {
      if (!this.selectedIds.length) { this.$message.warning('请先勾选要导出的客户'); return }
      if (!this.exportModules.length) { this.$message.warning('请至少勾选一个导出模块'); return }
      this.exporting = true
      exportApi.exportCustomerFull({
        ids: this.selectedIds.join(','),
        modules: this.exportModules.join(',')
      }).then(res => {
        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        const dateStr = new Date().toISOString().slice(0, 10)
        let filename = '客户信息_' + dateStr + '.xlsx'
        if (this.selectedIds.length === 1) {
          const cust = this.customerList.find(c => c.id === this.selectedIds[0])
          if (cust && cust.name) {
            filename = '客户信息_' + cust.name + '_' + dateStr + '.xlsx'
          }
        } else {
          filename = '客户信息_批量(' + this.selectedIds.length + '人)_' + dateStr + '.xlsx'
        }
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(link.href)
        this.exportDialogVisible = false
        this.$message.success('导出成功')
      }).catch(() => {
        this.$message.error('导出失败，请重试')
      }).finally(() => {
        this.exporting = false
      })
    },
    handleImport(file) {
      if (!file.raw) return
      exportApi.importCustomers(file.raw).then(res => {
        if (res.data.success) {
          this.$message.success(res.data.message)
          this.getCustomerList()
        } else {
          this.$message.error(res.data.message || '导入失败')
        }
      })
    },
    handleLegacyImport(file) {
      if (!file.raw) return
      // 第一步：先试运行（dryRun），让用户在弹窗里预览将要发生什么，确认后再正式导入
      this.legacyFile = file.raw
      this.legacyImporting = true
      legacyImportApi.import(file.raw, true).then(res => {
        this.legacyResult = res.data
        this.legacyResultVisible = true
      }).catch(err => {
        const msg = (err.response && err.response.data && err.response.data.message) || '预览失败'
        this.legacyResult = { success: false, message: msg }
        this.legacyResultVisible = true
      }).finally(() => { this.legacyImporting = false })
    },
    handleLegacyConfirm() {
      if (!this.legacyFile) return
      this.legacyImporting = true
      legacyImportApi.import(this.legacyFile, false).then(res => {
        this.legacyResult = res.data
        if (res.data.success) {
          this.$message.success(res.data.message || '导入完成')
          this.legacyResultVisible = false
          this.getCustomerList()
        }
      }).catch(err => {
        const msg = (err.response && err.response.data && err.response.data.message) || '导入失败'
        this.legacyResult = { success: false, message: msg }
      }).finally(() => { this.legacyImporting = false; this.legacyFile = null })
    },
    handleLegacyRevert(batchNo) {
      const msg = `确定撤销批次【${batchNo}】？将删除本次导入新建的客户档案、销售订单及历史出库记录，恢复到导入前的数据（已存在客户的字段更新不回滚）。<br/><br/>
<div style="padding:8px 10px;background:#fef0f0;border-left:3px solid #f56c6c;border-radius:3px;color:#f56c6c;font-size:12px;line-height:1.5">
  <strong>🔔【重要业务影响提示】</strong><br/>
  • 若该批次客户在导入后，业务员/客户已发起过<strong>「出库」</strong>（如新出库、送存货、尊贵卡等）：撤销将导致后续出库记录脱节、卡内剩余额度异常、存货台账混乱！<br/>
  • 若已产生后续回款、签字或欠款变更：撤销将影响财务与客户账目一致性。
</div>`
      this.$confirm(msg, '撤销导入确认', {
        dangerouslyUseHTMLString: true,
        type: 'warning',
        confirmButtonText: '确定撤销',
        cancelButtonText: '取消',
        confirmButtonClass: 'el-button--danger'
      }).then(() => {
        this.legacyImporting = true
        legacyImportApi.revert(batchNo).then(res => {
          if (res.data.success) {
            this.$message.success(res.data.message || '已撤销')
            this.legacyResultVisible = false
            this.getCustomerList()
          } else {
            this.$message.error(res.data.message || '撤销失败')
          }
        }).catch(err => {
          this.$message.error((err.response && err.response.data && err.response.data.message) || '撤销失败')
        }).finally(() => { this.legacyImporting = false })
      }).catch(() => {})
    },
    downloadLegacyTemplate() {
      // 后端动态生成最新模板（含最新列），避免静态文件忘了更新
      axios.get('/import/legacy/template', { responseType: 'blob' }).then(res => {
        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = '原系统客户导入模板.xlsx'
        a.click()
        setTimeout(() => window.URL.revokeObjectURL(url), 0)
      }).catch(() => this.$message.error('下载失败'))
    },
    getLabelType(label) {
      const map = { '尊贵卡-叶粉': 'warning', '休眠': 'danger', '正常': 'success' }
      return map[label] || ''
    },
    dormantTagType(statusText) {
      if (statusText === '休眠') return 'danger'
      if (statusText === '缓冲期') return 'warning'
      return 'success'  // 激活
    },
    getCategoryType(c) {
      const map = {
        '礼品': 'success',
        '产品试用': 'info',
        '新出库': 'primary',
        '送存货': '',
        '尊贵卡A': 'warning',
        '尊贵卡B': 'danger',
        '尊贵卡C': 'warning'
      }
      return map[c] != null ? map[c] : ''
    },
    formatDate(v) {
      if (!v) return ''
      return String(v).replace('T', ' ').slice(0, 19)
    },
    formatMoney(v) {
      const n = Number(v)
      if (!isFinite(n)) return '0.00'
      return n.toFixed(2)
    },
    nowStr() {
      const d = new Date()
      const pad = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    }
  }
}
</script>

<style scoped>
.mb-4 { margin-bottom: 16px; }
.mt-4 { margin-top: 16px; }
/* 搜索行：导入/导出/添加客户 按钮靠右，与搜索同一行 */
.customer-toolbar { display: flex; flex-wrap: wrap; align-items: center; }
.customer-toolbar .el-form-item { margin-bottom: 8px; }
.customer-toolbar .toolbar-actions { margin-left: auto; margin-right: 0; flex-shrink: 0; white-space: nowrap; }
/* 操作按钮组永远在一行（三个按钮不拆开），勾选显示"（N）"也不换行 */
.customer-toolbar .toolbar-actions .el-form-item__content { display: inline-flex; flex-wrap: nowrap; white-space: nowrap; }
/* 强制换行：让其后的筛选项另起第二行 */
.customer-toolbar .toolbar-break { flex-basis: 100%; width: 100%; height: 0; margin: 0; }

/* 展开行：模块化分区，每个模块 = 醒目标题条 + 卡片内容 */
.detail-panel { padding: 16px 22px 22px; background: #eef1f6; border-top: 2px solid #409eff; }
/* 模块标题条：左侧色条 + 浅蓝底，强分隔 */
.detail-panel-title {
  display: flex; align-items: center; gap: 8px;
  color: #1f2d3d; font-size: 14px; font-weight: 700;
  margin: 26px 0 0; padding: 11px 16px;
  background: linear-gradient(90deg,#e8f1ff 0%,#f3f8ff 100%);
  border: 1px solid #cfe0fb; border-left: 4px solid #409eff;
  border-radius: 8px 8px 0 0;
}
.detail-panel > .detail-panel-title:first-child { margin-top: 0; }
.detail-panel-title i { color: #409eff; font-size: 16px; }
.detail-panel-title .panel-subtitle { color: #8a94a6; font-size: 12px; font-weight: normal; margin-left: 6px; }
.detail-panel-title.clickable { cursor: pointer; user-select: none; }
.detail-panel-title.clickable:hover { background: linear-gradient(90deg,#dcebff 0%,#eaf3ff 100%); }
.detail-panel-title .toggle-arrow {
  order: -1; margin-right: 4px; font-size: 18px; font-weight: 700;
  color: #ff8c00; transition: transform .15s;
}
/* 内容卡片：与上方标题条无缝相连，整体成一张卡 */
.detail-card-row {
  background: #fff; border: 1px solid #cfe0fb; border-top: none;
  border-radius: 0 0 8px 8px; box-shadow: 0 2px 6px rgba(64,158,255,0.06);
  padding: 14px 16px; margin: 0 0 6px;
}
/* 标题条紧跟另一张内容卡（基础信息下的系统信息块）时，单独成卡 */
.detail-card-row + .detail-card-row { border-top: 1px solid #cfe0fb; border-radius: 8px; margin-top: 10px; }
.dbl-edit { cursor: pointer; transition: background .15s; }
.dbl-edit:hover { background: #f0f7ff; }
.detail-card-body { display: grid; gap: 8px; }
.detail-card-body.cols-4 { grid-template-columns: repeat(4, 1fr); }
.detail-card-body.cols-3 { grid-template-columns: repeat(3, 1fr); }
.dc-cell { display: flex; justify-content: flex-start; align-items: center; gap: 8px; padding: 6px 10px; background: #f8f9fb; border-radius: 4px; }
.dc-cell.w2 { grid-column: span 2; }
.dc-cell.w4 { grid-column: span 4; }
.dc-label { color: #909399; font-size: 12px; flex-shrink: 0; }
.dc-label::after { content: '：'; }
.dc-value { color: #303133; font-size: 13px; font-weight: 500; }
.detail-panel .rule-hints { margin-top: 10px; color: #909399; font-size: 12px; line-height: 1.8; padding: 8px 12px; background: #f5f7fa; border-radius: 4px; text-align: left; }
.detail-panel .rule-hints p { margin: 0; text-align: left; }
.detail-panel .muted { color: #909399; }
.detail-panel .warn { color: #f56c6c; }
.detail-panel .el-table { margin: 0; }
/* 内嵌页面模块：作为标题条下方的一张完整卡片，去掉内部 el-card 重复边框/留白 */
.detail-panel .so-embed-wrap { padding: 12px 14px; background: #fff; }
.detail-panel .so-embed-wrap >>> .el-card { border: none; box-shadow: none; background: transparent; }
.detail-panel .so-embed-wrap >>> .el-card__header { padding: 0 0 10px; border-bottom: 1px dashed #e4e7ed; margin-bottom: 12px; }
.detail-panel .so-embed-wrap >>> .el-card__header .clearfix > span:first-child { font-size: 13px; font-weight: 600; color: #409eff; }
.detail-panel .so-embed-wrap >>> .el-card__body { padding: 0; }
/* 内嵌页内部表格/分页不贴边 */
.detail-panel .so-embed-wrap >>> .el-table { margin: 0; }
.detail-panel .so-embed-wrap >>> .mb-4 { margin-bottom: 12px; }

/* 内嵌列表整体字号调小 */
.detail-panel .so-embed-wrap >>> .el-table { font-size: 12px; }
.detail-panel .so-embed-wrap >>> .el-table th .cell,
.detail-panel .so-embed-wrap >>> .el-table td .cell { font-size: 12px; }
/* 操作列按钮：字号 12px、高度 32px */
.detail-panel .so-embed-wrap >>> .el-table .el-button,
.detail-panel .so-embed-wrap >>> .el-table .el-button--mini,
.detail-panel .so-embed-wrap >>> .el-table .el-button--small {
  font-size: 12px !important; height: 30px; line-height: 1;
  padding: 0 12px; display: inline-flex; align-items: center;
}
.detail-panel .so-embed-wrap >>> .el-table .el-tag { font-size: 11px; }
.detail-panel .so-embed-wrap >>> .el-table .el-table__expand-icon { font-size: 12px; }

/* 工具条：搜索左对齐，操作按钮同一行靠右 */
.detail-panel .so-embed-wrap { text-align: left; }
.detail-panel .so-embed-wrap >>> .el-form--inline {
  display: flex; flex-wrap: wrap; align-items: center; text-align: left;
}
.detail-panel .so-embed-wrap >>> .el-form--inline .el-form-item {
  margin-right: 14px; margin-bottom: 8px; float: none;
}
/* 操作按钮组推到最右，与搜索同一行；审批管理无此组则不受影响 */
.detail-panel .so-embed-wrap >>> .el-form--inline .embed-actions {
  margin-left: auto; margin-right: 0;
}
/* 搜索框 + 搜索/重置/新建/导出按钮：统一 32px 高、小字号、图标垂直居中 */
.detail-panel .so-embed-wrap >>> .el-form--inline .el-form-item { margin-bottom: 6px; }
.detail-panel .so-embed-wrap >>> .el-form-item__label { font-size: 12px; line-height: 32px; }
.detail-panel .so-embed-wrap >>> .el-form--inline .el-input__inner,
.detail-panel .so-embed-wrap >>> .el-form--inline .el-input--small .el-input__inner,
.detail-panel .so-embed-wrap >>> .el-form--inline .el-input--medium .el-input__inner,
.detail-panel .so-embed-wrap >>> .el-form--inline .el-input--mini .el-input__inner,
.detail-panel .so-embed-wrap >>> .el-form--inline .el-select .el-input__inner,
.detail-panel .so-embed-wrap >>> .el-form--inline .el-date-editor .el-input__inner,
.detail-panel .so-embed-wrap >>> .el-form--inline .el-range-editor.el-input__inner {
  height: 32px !important; line-height: 32px !important; font-size: 12px;
}
/* 输入框/下拉的图标垂直居中，避免错位 */
.detail-panel .so-embed-wrap >>> .el-form--inline .el-input__icon { line-height: 32px; }
.detail-panel .so-embed-wrap >>> .el-form--inline .el-input__suffix { display: flex; align-items: center; top: 0; }
.detail-panel .so-embed-wrap >>> .el-form--inline .el-select .el-input .el-select__caret { line-height: 32px; }
.detail-panel .so-embed-wrap >>> .el-form--inline .el-range-editor .el-range-input { font-size: 12px; height: 100%; }
.detail-panel .so-embed-wrap >>> .el-form--inline .el-range-editor .el-range__icon,
.detail-panel .so-embed-wrap >>> .el-form--inline .el-range-editor .el-range__close-icon { line-height: 32px; }
/* 搜索/重置/新建/导出 按钮：与输入框同高 32px */
.detail-panel .so-embed-wrap >>> .el-form--inline .el-button {
  height: 32px; line-height: 1; padding: 0 14px; font-size: 12px;
}

/* 内嵌表格表头：柔和中性浅灰，和上方蓝色模块标题条区分但不扎眼 */
.detail-panel .so-embed-wrap >>> .el-table th {
  background: #eef0f3 !important;
}
.detail-panel .so-embed-wrap >>> .el-table th,
.detail-panel .so-embed-wrap >>> .el-table th .cell {
  color: #606266 !important; font-weight: 600;
}
.detail-panel .so-embed-wrap >>> .el-table th.is-leaf {
  border-bottom: 1px solid #dcdfe6;
}

/* 表格操作列：按钮文字/按钮不被截断 */
.detail-panel .so-embed-wrap >>> .el-table .cell { white-space: nowrap; }
.detail-panel .so-embed-wrap >>> .el-table .el-button {
  white-space: nowrap; padding-left: 8px; padding-right: 8px;
}
/* 操作列固定列高度自适应，避免裁切 */
.detail-panel .so-embed-wrap >>> .el-table__fixed-right,
.detail-panel .so-embed-wrap >>> .el-table__fixed { height: auto !important; }

/* 内嵌模块分页：紧凑、靠右、小字号，顶部细分隔线 */
/* 分页所在容器水平居中，避免被裁切 */
.detail-panel .so-embed-wrap >>> .mt-4 { text-align: center; }
.detail-panel .so-embed-wrap >>> .el-pagination {
  display: inline-block; margin: 8px auto 0; padding: 4px 0 0;
  font-size: 12px; white-space: normal; max-width: 100%;
}
.detail-panel .so-embed-wrap >>> .el-pagination .el-pagination__total,
.detail-panel .so-embed-wrap >>> .el-pagination .el-pagination__jump {
  font-size: 12px; color: #909399; margin: 0 8px 0 0;
}
.detail-panel .so-embed-wrap >>> .el-pagination .el-pager li,
.detail-panel .so-embed-wrap >>> .el-pagination .btn-prev,
.detail-panel .so-embed-wrap >>> .el-pagination .btn-next {
  min-width: 24px; height: 24px; line-height: 24px; font-size: 12px;
}
.detail-panel .so-embed-wrap >>> .el-pagination .el-select .el-input .el-input__inner {
  height: 24px !important; line-height: 24px !important; font-size: 12px;
}
.detail-panel .so-embed-wrap >>> .el-pagination .el-pagination__editor.el-input .el-input__inner {
  height: 24px !important; line-height: 24px !important;
}
</style>
<style>
/* 编辑客户对话框：紧凑统一的 3 列布局 */
.customer-dialog .el-dialog__body { padding: 18px 24px 8px; }
.customer-dialog .el-form-item { margin-bottom: 16px; }
.customer-dialog .el-form-item__label { font-weight: 500; }
.customer-dialog .el-divider { margin: 12px 0 18px; }
.customer-dialog .divider-text { color: #606266; font-size: 13px; font-weight: 500; }
.customer-dialog .rule-hints { color: #909399; font-size: 12px; line-height: 1.8; padding: 8px 12px; background: #f5f7fa; border-radius: 4px; }
.customer-dialog .rule-hints p { margin: 0; }
</style>
